import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/stat-customer-distribution'

export async function byUser(params) {
    return request(`${api.byUser.url}?${stringify(params)}`)
}

export async function byChannel(params) {
    return request(`${api.byChannel.url}?${stringify(params)}`)
}
